import { ChangeDetectorRef, Component, effect, inject, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { ButtonComponent } from '@atoms/button/button.component';
import { IconComponent } from '@atoms/icon/icon.component';
import { TooltipDirective } from '@directives/tooltip.directive';
import { FinancingFormService } from '@services/financing-form.service';
import { PhonePipe } from '@pipes/phone.pipe';

@Component({
  selector: 'app-form-header',
  imports: [RouterModule, TranslateModule, ButtonComponent, IconComponent, TooltipDirective, PhonePipe],
  templateUrl: './form-header.component.html',
  styleUrl: './form-header.component.scss',
})
export class FormHeaderComponent {
  private cd = inject(ChangeDetectorRef);
  private activatedRoute = inject(ActivatedRoute);
  public globals = inject(Globals);
  public financingFormService = inject(FinancingFormService);
  @Input() type: 'default' | 'car-valuation' = 'default';
  public carId: string | null = this.activatedRoute.snapshot.queryParamMap.get('car');
  public makeSlug: string | null = 'make';
  public modelSlug: string | null = 'model';

  constructor() {
    effect(() => {
      const car = this.financingFormService.financingFormData()?.message.car;
      if (car?.makeSlug) this.makeSlug = car.makeSlug;
      if (car?.modelSlug) this.modelSlug = car.modelSlug;
      this.cd.detectChanges();
    });
  }
}
